import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  Chip,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import StarIcon from "@material-ui/icons/Star";
import FooterPagination from "../../../components/footer-pagination/footer-pagination";
import { getFileUrl } from "../../../common/tools";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    maxHeight: window.outerHeight - 300,
  },
  table: {
    minWidth: 1100,
  },
}));

// Chỉ name, area, modifiedDate được backend hỗ trợ sắp xếp
const headCells = [
  { id: "avatar", label: "Ảnh" },
  { id: "code", label: "Mã dự án" },
  { id: "name", label: "Tên dự án", sortable: true },
  { id: "category", label: "Danh mục" },
  { id: "status", label: "Trạng thái" },
  { id: "investmentType", label: "Hình thức đầu tư" },
  { id: "investorName", label: "Chủ đầu tư" },
  { id: "area", label: "Diện tích", sortable: true, align: "right" },
  { id: "isActive", label: "Hiển thị", align: "center" },
  { id: "modifiedDate", label: "Cập nhật", sortable: true },
  { id: "actions", label: "" },
];

export const formatUtcDate = (value) =>
  value ? moment.utc(value).local().format("DD/MM/YYYY HH:mm") : "";

const ListInvestmentProject = ({
  data,
  totalItemCount,
  page,
  rowsPerPage,
  order,
  orderBy,
  onChangePage,
  onChangeRowsPerPage,
  onRequestSort,
  editAction,
  deleteAction,
}) => {
  const classes = useStyles();
  const totalPage = Math.ceil(totalItemCount / rowsPerPage);

  return (
    <Paper className={classes.paper}>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table} size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map((headCell) => (
                <TableCell
                  key={headCell.id}
                  align={headCell.align || "left"}
                  sortDirection={orderBy === headCell.id ? order : false}
                  className="pt-3 pb-3 text-nowrap"
                >
                  {headCell.sortable ? (
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : "asc"}
                      onClick={() => onRequestSort(headCell.id)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  ) : (
                    headCell.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length > 0 ? (
              data.map((row, index) => (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={row.id}
                  style={{
                    backgroundColor: index % 2 ? "#FFFFFF" : "#EEF0F2",
                  }}
                >
                  <TableCell>
                    <div
                      className="d-flex align-items-center justify-content-center bg-light"
                      style={{ width: 64, height: 44 }}
                    >
                      {row.avatarFile && row.avatarFile.filePreview && (
                        <img
                          src={getFileUrl(row.avatarFile.filePreview)}
                          alt={row.avatarFile.fileName}
                          style={{ maxWidth: "100%", maxHeight: "100%" }}
                        />
                      )}
                    </div>
                  </TableCell>
                  <TableCell className="text-nowrap">{row.code}</TableCell>
                  <TableCell>
                    {row.isFeatured && (
                      <Tooltip title="Dự án nổi bật">
                        <StarIcon
                          fontSize="small"
                          className="mr-1"
                          style={{ color: "#f5a623", verticalAlign: "text-bottom" }}
                        />
                      </Tooltip>
                    )}
                    {row.name}
                  </TableCell>
                  <TableCell>{row.category && row.category.name}</TableCell>
                  <TableCell>{row.status && row.status.name}</TableCell>
                  <TableCell>
                    {row.investmentType && row.investmentType.name}
                  </TableCell>
                  <TableCell>{row.investorName}</TableCell>
                  <TableCell align="right" className="text-nowrap">
                    {row.area !== null && row.area !== undefined
                      ? `${Number(row.area).toLocaleString("vi-VN")} ${row.areaUnit || ""}`
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {row.isActive ? (
                      <Chip size="small" color="primary" label="Hiển thị" />
                    ) : (
                      <Chip size="small" label="Ẩn" />
                    )}
                  </TableCell>
                  <TableCell className="text-nowrap">
                    {formatUtcDate(row.modifiedDate)}
                  </TableCell>
                  <TableCell align="right" className="text-nowrap">
                    <Tooltip title="Sửa">
                      <IconButton
                        aria-label="edit"
                        onClick={() => editAction(row.id)}
                      >
                        <EditIcon className="text-primary" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Xóa">
                      <IconButton
                        aria-label="delete"
                        onClick={() => deleteAction(row.id)}
                      >
                        <DeleteIcon className="text-danger" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow hover tabIndex={-1}>
                <TableCell colSpan={headCells.length} className="text-center">
                  Không có dữ liệu
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalItemCount > 0 ? (
        <FooterPagination
          totalItemCount={totalItemCount}
          currentPage={page}
          rowsPerPage={rowsPerPage}
          handleChangeRowsPerPage={onChangeRowsPerPage}
          handleChangePage={onChangePage}
          totalPage={totalPage}
        />
      ) : (
        ""
      )}
    </Paper>
  );
};

export default ListInvestmentProject;
